"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingChat = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stream_chat_react_1 = require("stream-chat-react");
const GamingChatInner_1 = require("./GamingChatInner");
const GamingChatNotification_1 = require("./GamingChatNotification");
const GamingThreadHeader_1 = require("./GamingThreadHeader");
const useChecklistTasks_1 = require("../../hooks/useChecklistTasks");
const useConnectUser_1 = require("../../hooks/useConnectUser");
const LayoutController_1 = require("../../context/LayoutController");
const MessageTimestampController_1 = require("../../context/MessageTimestampController");
const targetOrigin = "";
const GamingChat = ({ info }) => {
    const [channel, setChannel] = (0, react_1.useState)(null);
    const { memberListVisible, popUpText, upgradePanelVisible, chatVisible } = (0, LayoutController_1.useLayoutController)();
    const chatClient = (0, useConnectUser_1.useConnectUser)(info);
    (0, useChecklistTasks_1.useChecklist)({ chatClient, targetOrigin });
    (0, react_1.useEffect)(() => {
        if (!chatClient)
            return;
        const loadChat = async () => {
            const channel = chatClient.channel("livestream", info.channelId, {
                name: info.channelName,
            });
            await channel.watch();
            setChannel(channel);
        };
        loadChat();
    }, [chatClient]);
    if (!chatClient)
        return null;
    return ((0, jsx_runtime_1.jsx)("section", { className: `sidebar ${memberListVisible} ${chatVisible} ${upgradePanelVisible ? "show-upgrade" : ""}`, children: channel && ((0, jsx_runtime_1.jsxs)("div", { className: "chat-container", children: [(0, jsx_runtime_1.jsx)(stream_chat_react_1.Chat, { client: chatClient, children: (0, jsx_runtime_1.jsx)(stream_chat_react_1.Channel, { channel: channel, ThreadHeader: GamingThreadHeader_1.GamingThreadHeader, children: (0, jsx_runtime_1.jsx)(MessageTimestampController_1.MessageTimestampController, { children: (0, jsx_runtime_1.jsx)(GamingChatInner_1.GamingChatInner, { info: info }) }) }) }), popUpText && (0, jsx_runtime_1.jsx)(GamingChatNotification_1.GamingChatNotification, { text: popUpText })] })) }));
};
exports.GamingChat = GamingChat;
